import { InjectionToken } from '@angular/core';

export const VBC_HOST = new InjectionToken('VBC host for given environment');
